import React from 'react';

import { getLayout as getBaseLayout } from './Base';
import SEO from '../SEO';
import FooterRegular from '../Footer';
import FooterMinimal from '../FooterMinimal';
import HeaderMinimal from '../HeaderMinimal';

const LPLayout = ({ children, pageContext: { page }, location }) => {
  const getFoooter = (props) => {
    switch (props.footerStyle) {
      case 'Minimal':
        return <FooterMinimal {...props} isDark={props.heroDark} />;
      case 'Regular_With_Form':
        const isFormInFooter = props.form && props.featuredComponent !== 'Form';
        return <FooterRegular {...props} stickyForm={isFormInFooter} />;
      default:
        return <FooterRegular {...props} />;
    }
  };
  return (
    <React.Fragment>
      <SEO {...page} location={location} />
      <HeaderMinimal isDark={page.heroDark} />

      {children}

      {getFoooter(page)}
    </React.Fragment>
  );
};

export const getLayout = (props, element) =>
  getBaseLayout(<LPLayout {...props}>{element}</LPLayout>);

export default LPLayout;
